<template>
  <div>
    <InWarrantyInfoBlock v-if="isInWarranty" :conversation />

    <OutOfWarrantyInfoBlock
      v-if="!isInWarranty"
      :customer-issues="conversation.customerIssues"
      :label-return="conversation.labelReturn"
      :warranty-state="conversation.declaredWarrantyState"
    />
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import { isEmpty } from '@backmarket/utils/object/isEmpty'

import type { Conversation } from '~/api/seller-after-sales/types'

import InWarrantyInfoBlock from './components/InWarrantyInfoBlock/InWarrantyInfoBlock.vue'
import OutOfWarrantyInfoBlock from './components/OutOfWarrantyInfoBlock/OutOfWarrantyInfoBlock.vue'

const props = defineProps<{
  conversation: Conversation
}>()

const isInWarranty = computed(
  () =>
    isEmpty(props.conversation.declaredWarrantyState) ||
    props.conversation.declaredWarrantyState === 'IN_WARRANTY',
)
</script>
